import { jsx as _jsx } from "react/jsx-runtime";
import './where-is-my-car.sass';
import { IconButton } from '@mui/material';
import { memo, useCallback, useEffect } from 'react';
import { useMapEvents } from 'react-leaflet';
import { device_last_loc_selector } from 'entities/device.map.track/lib/selectors';
import { useAction, usePartialAppSelector } from 'shared/hooks/redux/hooks';
import { select_device_map } from 'shared/map/model/selectors';
import { setMapCenter } from 'shared/map/model/slice';
import { useBox } from 'shared/hooks/utils';
export const WhereIsMyCar = memo(function WhereIsMyCar(props) {
    const { device_id, follow, noFollow, setFollow } = props;
    const onWantMapCenter = useAction(setMapCenter);
    const device_last_loc = usePartialAppSelector(device_last_loc_selector, device_id);
    const boxedLastLoc = useBox(device_last_loc);
    const map_state = usePartialAppSelector(select_device_map, device_id);
    const onClickWhereIsMyCar = useCallback(() => {
        if (boxedLastLoc.current != null) {
            onWantMapCenter({ center: boxedLastLoc.current, device_id });
        }
    }, [device_id]);
    const onButtonClick = useCallback((event) => {
        event.preventDefault();
        if (follow) {
            noFollow();
        }
        else {
            setFollow();
        }
        onClickWhereIsMyCar();
    }, [follow]);
    useMapEvents({
        dragstart: noFollow,
    });
    useEffect(() => {
        if (boxedLastLoc.current != null && follow) {
            onWantMapCenter({ center: boxedLastLoc.current, device_id });
        }
    }, [map_state?.center, follow, device_id, boxedLastLoc.current]);
    return (_jsx(IconButton, { disableRipple: true, "aria-controls": "where-is-my-car", className: `ui-map-where-is-my-car${follow ? ' follow' : ''}`, onClick: onButtonClick, title: follow === null
            ? 'Где устройство?'
            : follow
                ? 'Отменить слежение'
                : 'Следить за машиной', size: "large" }));
});
